export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat("en-US").format(value);
}

export function formatNumberOrNull(value: number | null): string {
  if (value === null) return "-";
  return new Intl.NumberFormat("en-US").format(value);
}

/** Render a USD currency value with no fractional digits ("$1,234"). Null → "-". */
export function formatCurrencyOrNull(value: number | null): string {
  if (value === null) return "-";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatPercent(value: number | null): string {
  if (value === null) return "-";
  return `${value}%`;
}

export function formatCompact(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`;
  return value.toLocaleString();
}

export function formatRate(value: number): string {
  return `${Math.round(value)}%`;
}

export function formatWOS(value: number | null | undefined): string {
  // Dash, not 0, for the two "no meaningful WOS" cases:
  //  - null/undefined: the measure is suppressed for this row (e.g. a
  //    NetSuite-fallback first receiver with no inventory anchor).
  //  - NaN: "no remaining forecast sales in any future week" (unbounded DOS).
  if (value == null || Number.isNaN(value)) return "-";
  return Math.round(value).toString();
}

/** Compute weeks of supply: ending_inventory / avg(forecast_sales over next 4 periods). */
export function computeWOS(ending: number[], sales: number[]): number[] {
  return ending.map((inv, i) => {
    const horizon = sales.slice(i, Math.min(i + 4, sales.length))
    const avg = horizon.length > 0 ? horizon.reduce((a, v) => a + v, 0) / horizon.length : 0
    return avg > 0 ? Math.round((inv / avg) * 10) / 10 : 99.9
  })
}

export function capitalizeWords(text: string): string {
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/** Convert a snake_case column name to a human-readable label ("ship_to_location" → "Ship To Location"). */
export function toColumnLabel(name: string): string {
  return capitalizeWords(name.replace(/_/g, " "));
}
